
  import { Locale, format, formatDistance } from 'date-fns'
  import { PropType, defineComponent, ComputedRef, computed } from 'vue'

  import StaticMap from '@/components/Common/StaticMap.vue'
  import UserPicture from '@/components/User/UserPicture.vue'
  import { ROOT_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { IWorkout } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { getDateWithTZ } from '@/utils/dates'

  export default defineComponent({
    name: 'WorkoutCard',
    components: {
      StaticMap,
      UserPicture,
    },
    props: {
      workout: {
        type: Object as PropType<IWorkout>,
        required: false,
      },
      user: {
        type: Object as PropType<IUserProfile>,
        required: true,
      },
      sport: {
        type: Object as PropType<ISport>,
        required: false,
      },
    },
    setup() {
      const store = useStore()
      const locale: ComputedRef<Locale> = computed(
        () => store.getters[ROOT_STORE.GETTERS.LOCALE]
      )
      return {
        format,
        formatDistance,
        getDateWithTZ,
        locale,
      }
    },
  })
